import Print from '@focus-360/print';
import { setPrint } from 'features/siteMapSlice';
import gaFunction from 'lib/ga';
import { useAppDispatch, useAppSelector } from 'lib/hooks/redux';
import { useSiteMapQuery } from 'lib/hooks/queries';
import { useTheme } from 'styled-components';

/* =====================================================================
   This handles set up for the @f360 print modal package

   @returns: @f360 print modal package

======================================================================  */
const PrintModal = () => {
  // Redux Hooks and States
  const dispatch = useAppDispatch();
  const { selectedFilters, filterDictionary, legends } = useAppSelector((state) => ({
    selectedFilters: state.siteMap.selectedFilters,
    filterDictionary: state.siteMap.filterDictionary,
    legends: state.siteMap.legends,
  }));

  // Get Site Map Data from React-Query Cache (No Params)
  const siteMapData = useSiteMapQuery().data!;
  // Semantic Vars From Site Map Data
  const {
    applicationURL: { BASE_ASSET_URL },
    client,
    community: { applicationID: communityId, ...community },
  } = siteMapData;
  const communityFolder = community.printLogoFolder || community.logoFolder;
  const communityFileName = community.printLogoFileName || community.logoFileName;
  const clientFolder = client.printLogoFolder || client.logoFolder;
  const clientFileName = client.printLogoFileName || client.logoFileName;

  return (
    <Print
      currentPage="site-map"
      communityId={communityId}
      onClose={() => dispatch(setPrint(false))}
      baseAssetUrl={BASE_ASSET_URL}
      communityLogoSrc={`${BASE_ASSET_URL}/${communityId}/${communityFolder}/${communityFileName}`}
      clientLogoSrc={`${BASE_ASSET_URL}/${communityId}/${clientFolder}/${clientFileName}`}
      siteMap={siteMapData}
      selectedFilters={selectedFilters}
      filterDictionary={filterDictionary}
      legends={legends}
      gaFunction={gaFunction}
      theme={useTheme()}
    />
  );
};

export default PrintModal;
